import * as XLSX from "xlsx";
import { getWorksheet } from "./getWorksheet";

const extractTransferData = (data: { amount: number }[]) => {
  const initialTransferData = {
    totalCount: 0,
    totalAmount: 0,
  };

  const transferData = data.reduce((prevValue, crrValue) => (
    typeof crrValue.amount === "number" ?
      {
        totalAmount: prevValue.totalAmount + crrValue.amount,
        totalCount: prevValue.totalCount + 1,
      }
      : prevValue
  ), initialTransferData);

  return transferData;
};

export const processFile = (evt: ProgressEvent<FileReader>) => {
  const worksheet = getWorksheet(evt);
  const worksheetJsonData = XLSX.utils.sheet_to_json<{ amount: number }>(worksheet);
  return extractTransferData(worksheetJsonData);
};
